import { Box, FormControlLabel } from '@mui/material';
import { GridColDef, GridRenderCellParams, GridValueGetterParams } from '@mui/x-data-grid';
import { TreatmentPlanItemModel } from '../../../../../../../../services/api-client/contact-api.types';
import { OrangeGreenSwitch } from '../../../../../../../shared/switch/switch.styles';

const defaultProps = {
  sortable: false,
  flex: 1,
  minWidth: 70,
  maxWidth: 70
};

export const TreatmentPlanItemsTableColumns = (props: {
  isLoading: boolean;
  onSwitch: (item: TreatmentPlanItemModel, checked: boolean) => void;
  isTreatmentPlanCampaignActive: boolean;
}): GridColDef[] => [
  { field: 'id' },
  { ...defaultProps, field: 'tooth', headerName: 'T#', minWidth: 40, maxWidth: 40 },
  { field: 'code', headerName: 'Code', ...defaultProps },
  { ...defaultProps, field: 'description', headerName: 'Description', minWidth: 140, maxWidth: 400 },
  {
    field: 'totalCost',
    headerName: 'Actual',
    ...defaultProps,
    valueGetter: (params: GridValueGetterParams) => `$${Math.round(params?.value)}`
  },
  {
    field: 'insuranceEst',
    headerName: 'Est.',
    ...defaultProps,
    valueGetter: (params: GridValueGetterParams) => `$${Math.round(params?.value)}`
  },
  {
    field: 'patientCost',
    headerName: 'Patient',
    ...defaultProps,
    valueGetter: (params: GridValueGetterParams) => `$${Math.round(params?.value)}`
  },
  {
    ...defaultProps,
    field: 'incudeFollowUp',
    headerName: 'Follow Up',
    minWidth: 130,
    maxWidth: 130,
    renderCell: (params: GridRenderCellParams) => (
      <FormControlLabel
        control={
          <OrangeGreenSwitch
            color="default"
            checked={params.value}
            disabled={props.isLoading || !props.isTreatmentPlanCampaignActive}
            onClick={(e: any) => props.onSwitch(params.row, e.target.checked)}
          />
        }
        label={<Box sx={{ fontSize: '13px' }}>{params.value ? 'Include' : 'Exclude'}</Box>}
        disabled={props.isLoading || !props.isTreatmentPlanCampaignActive}
      />
    )
  }
];
